import { dmnStorage } from "../dmnStorage";

export type RunsheetConfigDataStorageType = {
  showTimeDividers: boolean;
  showHeaderRow: boolean;
};

export const runsheetConfigStorageDefault: RunsheetConfigDataStorageType = {
  showTimeDividers: true,
  showHeaderRow: true
};

export const getRunsheetConfigFromStorage =
  async (): Promise<RunsheetConfigDataStorageType> => {
    const runsheetConfig = await dmnStorage.get("runsheetConfig");
    return runsheetConfig ?? runsheetConfigStorageDefault;
  };

export const setRunsheetConfigToStorage = async (
  runsheetConfig: RunsheetConfigDataStorageType
): Promise<void> => {
  await dmnStorage.add("runsheetConfig", runsheetConfig);
};
